import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function FinalCloseSection() {
  return <section className="w-full bg-warm-white py-16 px-6 md:py-24 border-t border-border-gray/30" data-id="element-25">
      <div className="max-w-reading mx-auto text-center" data-id="element-26">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-27">
          <h2 className="text-3xl md:text-4xl font-serif text-charcoal mb-8 leading-tight" data-id="element-28">
            What would it change for you if you could sleep a full block again?
          </h2>

          <div className="text-xl md:text-2xl text-charcoal/80 mb-12 space-y-2 font-serif italic" data-id="element-29">
            <p data-id="element-30">Not forever. Not perfectly.</p>
            <p data-id="element-31">Just enough to feel steady in your body again.</p>
          </div>

          <p className="text-lg text-charcoal font-medium mb-8" data-id="element-32">
            If you're ready, download The Quiet Bladder Reset and run the
            protocol tonight.
          </p>

          <button onClick={() => {
          document.getElementById('pricing')?.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
          });
        }} className="w-full md:w-auto bg-amber hover:bg-amber-hover text-white text-xl font-bold py-4 px-10 rounded-lg shadow-md transition-all transform hover:scale-[1.02] flex items-center justify-center gap-2 mx-auto" data-id="element-33">
            Get the Reset — $6.36 <ArrowRight className="w-6 h-6" data-id="element-34" />
          </button>
        </motion.div>
      </div>
    </section>;
}